/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  CostOptimizationResponse,
  CostOptimizationResponseRequest,
  SunoCreditsResponse,
} from "../../models";

import { customInstance } from "../../custom-instance";
import type { ErrorType, BodyType } from "../../custom-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Get cache effectiveness statistics
 * @summary 캐시 효율 통계
 */
export const costOptimizationCacheStats = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<CostOptimizationResponse>(
    { url: `/api/cost-optimization/cache-stats/`, method: "GET", signal },
    options,
  );
};

export const getCostOptimizationCacheStatsQueryKey = () => {
  return [`/api/cost-optimization/cache-stats/`] as const;
};

export const getCostOptimizationCacheStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof costOptimizationCacheStats>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof costOptimizationCacheStats>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCostOptimizationCacheStatsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof costOptimizationCacheStats>>
  > = ({ signal }) => costOptimizationCacheStats(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof costOptimizationCacheStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CostOptimizationCacheStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof costOptimizationCacheStats>>
>;
export type CostOptimizationCacheStatsQueryError = ErrorType<unknown>;

export function useCostOptimizationCacheStats<
  TData = Awaited<ReturnType<typeof costOptimizationCacheStats>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof costOptimizationCacheStats>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof costOptimizationCacheStats>>,
          TError,
          Awaited<ReturnType<typeof costOptimizationCacheStats>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCostOptimizationCacheStats<
  TData = Awaited<ReturnType<typeof costOptimizationCacheStats>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof costOptimizationCacheStats>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof costOptimizationCacheStats>>,
          TError,
          Awaited<ReturnType<typeof costOptimizationCacheStats>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCostOptimizationCacheStats<
  TData = Awaited<ReturnType<typeof costOptimizationCacheStats>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof costOptimizationCacheStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 캐시 효율 통계
 */

export function useCostOptimizationCacheStats<
  TData = Awaited<ReturnType<typeof costOptimizationCacheStats>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof costOptimizationCacheStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCostOptimizationCacheStatsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get comprehensive cost optimization dashboard
 * @summary 비용 최적화 대시보드
 */
export const costOptimizationDashboard = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<CostOptimizationResponse>(
    { url: `/api/cost-optimization/dashboard/`, method: "GET", signal },
    options,
  );
};

export const getCostOptimizationDashboardQueryKey = () => {
  return [`/api/cost-optimization/dashboard/`] as const;
};

export const getCostOptimizationDashboardQueryOptions = <
  TData = Awaited<ReturnType<typeof costOptimizationDashboard>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof costOptimizationDashboard>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCostOptimizationDashboardQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof costOptimizationDashboard>>
  > = ({ signal }) => costOptimizationDashboard(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof costOptimizationDashboard>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CostOptimizationDashboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof costOptimizationDashboard>>
>;
export type CostOptimizationDashboardQueryError = ErrorType<unknown>;

export function useCostOptimizationDashboard<
  TData = Awaited<ReturnType<typeof costOptimizationDashboard>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof costOptimizationDashboard>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof costOptimizationDashboard>>,
          TError,
          Awaited<ReturnType<typeof costOptimizationDashboard>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCostOptimizationDashboard<
  TData = Awaited<ReturnType<typeof costOptimizationDashboard>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof costOptimizationDashboard>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof costOptimizationDashboard>>,
          TError,
          Awaited<ReturnType<typeof costOptimizationDashboard>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCostOptimizationDashboard<
  TData = Awaited<ReturnType<typeof costOptimizationDashboard>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof costOptimizationDashboard>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 비용 최적화 대시보드
 */

export function useCostOptimizationDashboard<
  TData = Awaited<ReturnType<typeof costOptimizationDashboard>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof costOptimizationDashboard>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCostOptimizationDashboardQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get model performance metrics and comparison
 * @summary 모델 성능 메트릭
 */
export const costOptimizationMetrics = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<CostOptimizationResponse>(
    { url: `/api/cost-optimization/metrics/`, method: "GET", signal },
    options,
  );
};

export const getCostOptimizationMetricsQueryKey = () => {
  return [`/api/cost-optimization/metrics/`] as const;
};

export const getCostOptimizationMetricsQueryOptions = <
  TData = Awaited<ReturnType<typeof costOptimizationMetrics>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof costOptimizationMetrics>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCostOptimizationMetricsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof costOptimizationMetrics>>
  > = ({ signal }) => costOptimizationMetrics(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof costOptimizationMetrics>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CostOptimizationMetricsQueryResult = NonNullable<
  Awaited<ReturnType<typeof costOptimizationMetrics>>
>;
export type CostOptimizationMetricsQueryError = ErrorType<unknown>;

export function useCostOptimizationMetrics<
  TData = Awaited<ReturnType<typeof costOptimizationMetrics>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof costOptimizationMetrics>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof costOptimizationMetrics>>,
          TError,
          Awaited<ReturnType<typeof costOptimizationMetrics>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCostOptimizationMetrics<
  TData = Awaited<ReturnType<typeof costOptimizationMetrics>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof costOptimizationMetrics>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof costOptimizationMetrics>>,
          TError,
          Awaited<ReturnType<typeof costOptimizationMetrics>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCostOptimizationMetrics<
  TData = Awaited<ReturnType<typeof costOptimizationMetrics>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof costOptimizationMetrics>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 모델 성능 메트릭
 */

export function useCostOptimizationMetrics<
  TData = Awaited<ReturnType<typeof costOptimizationMetrics>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof costOptimizationMetrics>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCostOptimizationMetricsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get optimization recommendations
 * @summary 최적화 권장사항
 */
export const costOptimizationRecommendations = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<CostOptimizationResponse>(
    { url: `/api/cost-optimization/recommendations/`, method: "GET", signal },
    options,
  );
};

export const getCostOptimizationRecommendationsQueryKey = () => {
  return [`/api/cost-optimization/recommendations/`] as const;
};

export const getCostOptimizationRecommendationsQueryOptions = <
  TData = Awaited<ReturnType<typeof costOptimizationRecommendations>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof costOptimizationRecommendations>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCostOptimizationRecommendationsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof costOptimizationRecommendations>>
  > = ({ signal }) => costOptimizationRecommendations(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof costOptimizationRecommendations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CostOptimizationRecommendationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof costOptimizationRecommendations>>
>;
export type CostOptimizationRecommendationsQueryError = ErrorType<unknown>;

export function useCostOptimizationRecommendations<
  TData = Awaited<ReturnType<typeof costOptimizationRecommendations>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof costOptimizationRecommendations>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof costOptimizationRecommendations>>,
          TError,
          Awaited<ReturnType<typeof costOptimizationRecommendations>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCostOptimizationRecommendations<
  TData = Awaited<ReturnType<typeof costOptimizationRecommendations>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof costOptimizationRecommendations>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof costOptimizationRecommendations>>,
          TError,
          Awaited<ReturnType<typeof costOptimizationRecommendations>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCostOptimizationRecommendations<
  TData = Awaited<ReturnType<typeof costOptimizationRecommendations>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof costOptimizationRecommendations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 최적화 권장사항
 */

export function useCostOptimizationRecommendations<
  TData = Awaited<ReturnType<typeof costOptimizationRecommendations>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof costOptimizationRecommendations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCostOptimizationRecommendationsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Simulate cost optimization scenarios
 * @summary 비용 최적화 시뮬레이션
 */
export const costOptimizationSimulate = (
  costOptimizationResponseRequest: BodyType<CostOptimizationResponseRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<CostOptimizationResponse>(
    {
      url: `/api/cost-optimization/simulate/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: costOptimizationResponseRequest,
      signal,
    },
    options,
  );
};

export const getCostOptimizationSimulateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof costOptimizationSimulate>>,
    TError,
    { data: BodyType<CostOptimizationResponseRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof costOptimizationSimulate>>,
  TError,
  { data: BodyType<CostOptimizationResponseRequest> },
  TContext
> => {
  const mutationKey = ["costOptimizationSimulate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof costOptimizationSimulate>>,
    { data: BodyType<CostOptimizationResponseRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return costOptimizationSimulate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CostOptimizationSimulateMutationResult = NonNullable<
  Awaited<ReturnType<typeof costOptimizationSimulate>>
>;
export type CostOptimizationSimulateMutationBody =
  BodyType<CostOptimizationResponseRequest>;
export type CostOptimizationSimulateMutationError = ErrorType<unknown>;

/**
 * @summary 비용 최적화 시뮬레이션
 */
export const useCostOptimizationSimulate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof costOptimizationSimulate>>,
      TError,
      { data: BodyType<CostOptimizationResponseRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof costOptimizationSimulate>>,
  TError,
  { data: BodyType<CostOptimizationResponseRequest> },
  TContext
> => {
  const mutationOptions = getCostOptimizationSimulateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get Suno API credit balance and usage statistics
 * @summary Suno API 크레딧 잔액
 */
export const costOptimizationSunoCredits = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<SunoCreditsResponse>(
    { url: `/api/cost-optimization/suno-credits/`, method: "GET", signal },
    options,
  );
};

export const getCostOptimizationSunoCreditsQueryKey = () => {
  return [`/api/cost-optimization/suno-credits/`] as const;
};

export const getCostOptimizationSunoCreditsQueryOptions = <
  TData = Awaited<ReturnType<typeof costOptimizationSunoCredits>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof costOptimizationSunoCredits>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCostOptimizationSunoCreditsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof costOptimizationSunoCredits>>
  > = ({ signal }) => costOptimizationSunoCredits(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof costOptimizationSunoCredits>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CostOptimizationSunoCreditsQueryResult = NonNullable<
  Awaited<ReturnType<typeof costOptimizationSunoCredits>>
>;
export type CostOptimizationSunoCreditsQueryError = ErrorType<unknown>;

export function useCostOptimizationSunoCredits<
  TData = Awaited<ReturnType<typeof costOptimizationSunoCredits>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof costOptimizationSunoCredits>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof costOptimizationSunoCredits>>,
          TError,
          Awaited<ReturnType<typeof costOptimizationSunoCredits>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCostOptimizationSunoCredits<
  TData = Awaited<ReturnType<typeof costOptimizationSunoCredits>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof costOptimizationSunoCredits>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof costOptimizationSunoCredits>>,
          TError,
          Awaited<ReturnType<typeof costOptimizationSunoCredits>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCostOptimizationSunoCredits<
  TData = Awaited<ReturnType<typeof costOptimizationSunoCredits>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof costOptimizationSunoCredits>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Suno API 크레딧 잔액
 */

export function useCostOptimizationSunoCredits<
  TData = Awaited<ReturnType<typeof costOptimizationSunoCredits>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof costOptimizationSunoCredits>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCostOptimizationSunoCreditsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
